import React from 'react'
import {useSelector} from "react-redux"
import {Navigate, useLocation} from "react-router-dom"

const ProtectedRoute = ({children, roles = ["admin"]}) => {
    const { isAuthenticated, user, loading } = useSelector((state) => state.user);
    const userDetails = JSON.parse(localStorage.getItem('User') || "null");
    let location = useLocation();

    const effectiveUser = user?.role ? user : userDetails?.user;
    const effectiveAuth = Boolean(isAuthenticated || effectiveUser);

    if (loading !== false) {
        return children;
    }

    if (!effectiveAuth) {
        return <Navigate to="/Login" state={{ from: location}} replace />
    }

    if(!roles.includes(effectiveUser?.role)) {
        return <Navigate to="/" state={{ from: location}} replace />
    }
 return children

};

export default ProtectedRoute;
